import "./RadioButtonFlat.css";

function RadioButtonFlat({
  options,
  selectedOption,
  onChange,
  name,
  displayName,
}) {
  const labelValue = displayName || name;
  const shouldAppendColon =
    typeof labelValue === "string" || typeof labelValue === "number";

  return (
    <div className="radio-buttons-flat-container">
      {labelValue ? (
        <div className="radio-buttons-flat-label App-text-medium">
          {labelValue}
          {shouldAppendColon ? ":" : null}
        </div>
      ) : null}
      <div className="radio-buttons-flat-options">
        {options.map(option => {
          // Handle both simple strings and option objects with label/value
          const value = typeof option === "object" ? option.value : option;
          const label = typeof option === "object" ? option.label : option;

          return (
            <label className={"App-text-medium"} key={value}>
              <input
                type="radio"
                name={name}
                value={value}
                checked={selectedOption === value}
                onChange={() => onChange({ target: { name, value } })}
              />
              {label}
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default RadioButtonFlat;
